/* RESPONSIBLE TEAM: team-standalone */
import { BaseConfig } from '@intercom/composer-ember';
import type AttributeInfoResolver from 'embercom/lib/common/template-attribute-resolver';

const DEFAULT_COMPOSER_MAX_CHARACTER_COUNT = 150;

export class StandaloneComposerConfig extends BaseConfig {
  autoFocus = true;
  textDirection = 'ltr' as const;
  allowedBlocks = ['paragraph'];
  allowedInline = [];
  allowTextAlignment = false;
  singleBlockMode = true;
  isPlaintext = true;
  maxCharacterCount: number;
  tools = [{ name: 'template-inserter' }, { name: 'fallback-editor' }];
  experimental = {
    hideInsertersOnMouseOut: true,
  };
  templating: { picker: string; resolver: AttributeInfoResolver };

  constructor({
    resolver,
    placeholder = '',
    maxCharacterCount = DEFAULT_COMPOSER_MAX_CHARACTER_COUNT,
    singleBlockMode = true,
    autoFocus = true,
  }: {
    resolver: AttributeInfoResolver;
    placeholder?: string;
    maxCharacterCount?: number;
    singleBlockMode?: boolean;
    autoFocus?: boolean;
  }) {
    super();
    this.placeholder = placeholder;
    this.maxCharacterCount = maxCharacterCount;
    this.singleBlockMode = singleBlockMode;
    this.autoFocus = autoFocus;
    this.templating = { picker: 'common/attribute-picker', resolver };
  }
}
